import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './FAQ.css';

const FAQ = () => {
  const [openItem, setOpenItem] = useState(0);

  const faqItems = [
    {
      question: "How does CrackIT Copilot work?",
      answer: "CrackIT transcribes live audio in 70+ languages and streams structured suggestions tailored to your resume, job description, and role."
    },
    {
      question: "How fast are the live responses?",
      answer: "Audio is transcribed with Whisper v3 and answered via GPT-4o / Claude 3.5 in under 180ms without interrupting your call."
    },
    {
      question: "Is it completely undetectable during screen shares?",
      answer: "Yes. Our native desktop app uses hardware-level window exclusions, making it invisible to Zoom, Google Meet, Teams, and screen recorders."
    },
    {
      question: "What interview formats are supported?",
      answer: "Technical coding rounds (DSA/LeetCode), system design architecture, and behavioral STAR interviews across software engineering and product."
    },
    {
      question: "Can I tailor answers to my resume?",
      answer: "Yes. Upload your resume and paste the job description. The AI anchors responses and anecdotes to your actual work experience."
    },
    {
      question: "How do credits and billing work?",
      answer: "Pay only for what you use with non-expiring credits and zero subscriptions. Instant checkout via UPI, cards, and netbanking."
    }
  ];

  const toggleItem = (index) => {
    setOpenItem(openItem === index ? null : index);
  };

  return (
    <section className="coprep-faq-section" id="faq">
      <div className="coprep-faq-container">
        
        {/* Header */}
        <motion.div 
          className="section-header-centered"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <div className="badge-pill">FAQ</div>
          <h2 className="section-main-title">
            Common <span className="gradient-primary">Questions</span>
          </h2>
          <p className="section-main-subtitle">
            Everything you need to know about stealth mode and setup.
          </p>
        </motion.div>

        {/* FAQ Accordion List */}
        <div className="faq-modern-accordion">
          {faqItems.map((item, index) => {
            const isOpen = openItem === index;
            return (
              <motion.div 
                key={index}
                className={`faq-accordion-item glass-card ${isOpen ? 'item-open' : ''}`}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.08 }}
                viewport={{ once: true }}
              >
                <button 
                  className="faq-question-trigger"
                  onClick={() => toggleItem(index)}
                  aria-expanded={isOpen}
                >
                  <span className="question-title-text">{item.question}</span>
                  <div className={`faq-chevron-circle ${isOpen ? 'chevron-rotated' : ''}`}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>
                </button>

                <AnimatePresence>
                  {isOpen && (
                    <motion.div 
                      className="faq-answer-collapse"
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.25, ease: 'easeInOut' }}
                    >
                      <div className="answer-inner-text">
                        <p>{item.answer}</p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>

        {/* Help Center / Contact CTA */}
        <div className="faq-contact-card glass-card">
          <div>
            <h4 className="contact-card-title">Still have questions?</h4>
            <p className="contact-card-sub">Our team is available 24/7 to help you configure your stealth copilot.</p>
          </div>
          <button 
            className="btn-secondary"
            onClick={() => {
              window.open('mailto:support@crackit.si?subject=Question%20about%20CrackIT%20AI', '_blank');
            }}
          >
            <span>Contact Support →</span>
          </button>
        </div>

      </div>
    </section>
  );
};

export default FAQ;
